<!--公示信息-->
<template>
  <div>
    <div class="content" id="pubilcyInfo">
      <div class="news">
        <div class="locate">
          <p>当前位置 > 新闻资讯 > 公示信息</p>
        </div>
        <el-divider></el-divider>
        <div class="detail">
          <p class="title">
            上海市嘉定区公共租赁住房准入资格审核公示
          </p>
          <div class="mainInfo1">
              <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
              根据《本市发展公共租赁住房的实施意见》（沪府发〔2010〕32号）和《嘉定区公共租赁住房管理办法（试行）》的有关规定，
              按照“公开、公平、公正”的原则做好公共租赁住房申请审核工作，现将经区住房保障机构审核通过，
              符合申请公共租赁住房的本区申请人名单公示如下：
          </div>
          <div class="list">
              <el-table :data="list" stripe style="width: 100%">
                  <el-table-column type="index"  width="50" align="center">
                  </el-table-column>
                  <el-table-column prop="name" label="姓名" width="180" align="center">
                  </el-table-column>
                  <el-table-column prop="certNo" label="身份证号" align="center">
                  </el-table-column>
                  <el-table-column prop="publicDate" label="公示开始时间" align="center">
                  </el-table-column>
                  <el-table-column prop="publicEndDate" label="公示结束时间" align="center">
                  </el-table-column>
              </el-table>
          </div>
          <div class="mainInfo2">
              公示单位：上海市嘉定区住房保障事务中心<br />
              接待地点：上海市嘉定区金沙路68号606室<br />
              接待时间：周一至周五9:00-11:00，13:30-16:30<br />
              举报电话：59530689
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PortalApi from "@/api/portal/index";
export default {
  data() {
    return {
      list: []
    };
  },
  methods: {
    getData() {
      PortalApi.getPublicyInfo()
        .then(
          (res) => {
            this.list = res.data;
          },
          (err) => {
            this.$message({
              message: err,
              center: true,
            });
          }
        )
        .catch((error) => {
          this.$message({
            message: error,
            center: true,
          });
        });
    },
    indexMethod(index){
      return index;
    }
  },
  mounted() {
    this.getData();
  }
};
</script>

<style lang="less" scoped>
#pubilcyInfo {
  .news {
    width: 1176px;
    height: auto;
    margin: 41px auto;
    display: block;
  }

  .news .locate {
    padding-top: 27px;
    width: 270px;
    height: 15px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    line-height: 22px;
    text-align: left;
  }

  .detail {
    margin-top: 46px;
    text-align: center;
  }

  .title {
    height: 30px;
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #2c2c2c;
    line-height: 48px;
  }

  .mainInfo1,.mainInfo2 {
    text-align: left;
    margin-top: 34px;
    font-size: 16px;
    font-weight: 400;
    color: #343434;
    line-height: 48px;
    text-indent:2em;
  }

  .mainInfo2 {
    text-align: left;
    text-indent:0;
  }
}
</style>